export default "__VITE_ASSET__DW91dEdg__"